export default "__VITE_ASSET__DIKbMDJB__"